module.exports = __webpack_public_path__ + "img/notifications-white.aefebd3a.svg";